function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceAvailableAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 21.56,
    cy: 20.9,
    r: 4.9,
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.56,
    cy: 20.9,
    r: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.86 20.59 21.86 18.3 20.71 18.3 20.71 21.75 21.86 21.75 24.15 21.75 24.15 20.59 21.86 20.59",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24,17.3c-2.84,0-5.13-2.64-5.13-5.77a5.27,5.27,0,0,1,5-5.53h.17a5.28,5.28,0,0,1,5.19,5.36v0h0v.17C20.38,14.69,18.07,17.3,15.24,17.3Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.08,20.9v-.3a4.12,4.12,0,0,1-2.59-.88,6.47,6.47,0,0,0-1.17-1,2,2,0,0,0-2.48.4,18.74,18.74,0,0,0-2.63,4L5.77,24c-.17.39-.36,1.07-.09,1.39A2,2,0,0,0,7.26,26h10.3A6.44,6.44,0,0,1,15.08,20.9Z",
    style: {
      fill: "#6bae44"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableAway);
export default __webpack_public_path__ + "static/media/presence-available-away.038ae8d8.svg";
export { ForwardRef as ReactComponent };